import Leads from "./components/Leads";

export default Leads;
